import React, { useEffect } from "react";
import { useRootAppStore } from "@hooks";
import { observer } from "mobx-react";
import { ChatToggleButton, ChatBox } from "@features/chat/desktop";
import ErrorBoundaryWithPropagation from "@components/boundary/ErrorBoundaryWithPropagation";

export default observer(function ChatContainer() {
	const { chatViewStore } = useRootAppStore();

	useEffect(() => {
		return () => chatViewStore.onDispose();
	}, []);

	return (
		<ErrorBoundaryWithPropagation
			componentName={"Desktop/ChatContainer.tsx"}
		>
			<div className="chat">
				<ChatBox />
				<ChatToggleButton />
			</div>
		</ErrorBoundaryWithPropagation>
	);
});
